import { useState } from 'react';
import { useAuth } from '@/hooks/useAuth';

export function AuthGate() {
  const { login } = useAuth();
  const [value, setValue] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!value.trim()) return;
    try {
      const res = await fetch('/api/dashboard/overview', {
        headers: { Authorization: `Bearer ${value.trim()}` },
      });
      if (res.ok) {
        login(value.trim());
        setError('');
      } else {
        setError('Invalid token');
      }
    } catch {
      setError('Connection failed');
    }
  };

  return (
    <div
      data-testid="ops-auth-gate"
      className="min-h-screen flex items-center justify-center bg-slate-950"
    >
      <form onSubmit={handleSubmit} className="w-full max-w-sm p-6">
        <h1 className="text-lg font-semibold text-slate-200 mb-1">OPS NOC</h1>
        <p className="text-xs text-slate-500 mb-6">ForceShield Operations Dashboard</p>
        <label className="block text-xs text-slate-400 mb-1">API Token</label>
        <input
          data-testid="ops-auth-token-input"
          type="password"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-lg text-sm text-slate-200 focus:outline-none focus:border-slate-500"
          placeholder="Enter OPS_TOKEN"
          autoFocus
        />
        {error && (
          <p data-testid="ops-auth-error" className="text-xs text-red-400 mt-1">
            {error}
          </p>
        )}
        <button
          data-testid="ops-auth-submit"
          type="submit"
          className="w-full mt-4 px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-sm text-slate-200 hover:bg-slate-700 transition-colors"
        >
          Authenticate
        </button>
      </form>
    </div>
  );
}
